export default __webpack_public_path__ + "static/media/car1.12b1ceab.jpeg";